<template>
  <div class="labeled-pet-type-selector">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <PetTypeSelector
      ref="petTypeSelector"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :empty-state-text="emptyStateText"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import PetTypeSelector from '../pet-type-selector';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    label: {
      type: String,
      default: 'Тип тварини',
    },
    placeholder: {
      type: String,
      default: 'Оберіть тип тварини',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId: `pet-type-selector-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, PetTypeSelector },
  computed: {
    getPetTypeSelect() {
      return this.$refs.petTypeSelector;
    },
  },
  methods: {
    generateRandomId,
  },
};
</script>